import { Component, Host, h, Prop, Method } from "@stencil/core";

@Component({
	tag: "smart-float-div",
	styleUrl: "smart-float-div.scss",
	shadow: true,
})
export class SmartFloatDiv {
	private wrapperEl?: HTMLDivElement;

	@Prop() direction?: "column" | "row" = "column";
	@Prop() position?: "top" | "bottom" = "bottom";

	@Method()
	async getProperties() {
		return this.wrapperEl;
	}

	render() {
		return (
			<Host part="float-div-element">
				<div 
					ref={ref => this.wrapperEl = ref}
					class={{
						"float-div": true,
						[this.direction]: !!this.direction,
						[this.position]: !!this.position
					}}>
					<slot></slot>
				</div>
			</Host>
		);
	}
}
